import planTemplate from "../templates/pages/plantemplate.html?raw";
import NavBar from "../sections/navbar.ts";
import { getStringFromLocalStorage, saveJsonToLocalStorage } from "../services/localStorage.ts";
import { Page } from "./base.ts";
import { getChildElementSelector, getElementById, setContent } from "../services/dom.ts";
import { getApi } from "../services/api.ts";
import Footer from "../sections/footer.ts";
import { Meals } from "../types/plan.ts";
import { EWeekday, StandardWeekdays } from "../types/date.ts";
import { IUser } from "../types/user.ts";
import MealPlanTemplateItem from "../sections/mealplantemplateitem.ts";

const apiUrl = import.meta.env.VITE_API_URL as string;
const apiToken = getStringFromLocalStorage("idToken");

export default class PlanTemplatePage extends Page {
  private householdUsers: IUser[] = [];
  constructor() {
    super(planTemplate);
    this.loadPage();
  }

  private async loadPage(): Promise<void> {
    // Create navbar and footer immediately
    new NavBar();
    new Footer();

    // Handle any custom attributes (data-toggle-section, data-model)
    super.handleCustomAttributes();

    // Initialize stores and load data
    await super.init();
    await this.loadData();

    // Open the content
    setContent("plantemplate");
    console.log("load complete")
  }

  private async loadData(): Promise<void> {
    // Get API Data
    await Promise.all([
      this.getHouseholdUsers(),
    ]);
    const templateNameTemplate = document.querySelector("[data-for-each=templateNames]") as HTMLOptionElement;
    const templateNameTemplateParent = templateNameTemplate.parentElement as HTMLSelectElement;
    templateNameTemplate.classList.remove("hidden");
    this.planTemplateStore.planTemplates.forEach((planTemplate) => {
      const templateNameClone = templateNameTemplate.cloneNode(true) as HTMLOptionElement;
      templateNameClone.textContent = `Template ${planTemplate}`;
      templateNameClone.value = planTemplate.toString();
      templateNameTemplate.before(templateNameClone);
    });
    templateNameTemplate.classList.add("hidden");
    templateNameTemplateParent.addEventListener("change", (event: any) => {
      this.loadMealPlanTemplate(event.target!.selectedOptions[0]!.value as number);
    });
    getElementById("plantemplate_createnew").addEventListener("click", () => {
      this.createNewTemplate();
    });
  }

  private async getHouseholdUsers(): Promise<void> {
    try {
      const householdUsers = await getApi(apiUrl, "household", apiToken);
      this.householdUsers = householdUsers;
      saveJsonToLocalStorage("householdUsers", householdUsers);
    } catch (e: any) {
      this.message.timedMessage(`⚠ Unexpected error getting household users ⚠`);
      console.log(e);
      getElementById("plan_loading").classList.add("hidden");
      getElementById("plan_content").classList.add("hidden")
      getElementById("plan_error").classList.remove("hidden");
    }
  }

  private loadMealPlanTemplate(id: number): void {
    // Populate Day Of Week Headers
    const dateListTemplate = document.querySelector("[data-for-each=dateList]") as HTMLElement;
    const dateListParent = dateListTemplate.parentElement!;
    StandardWeekdays.forEach((day) => {
      const dateElement = dateListTemplate.cloneNode(true) as HTMLElement;
      this.populateWeekday(day, dateElement, id);
      dateListParent.appendChild(dateElement);
    });
    dateListTemplate.classList.add("hidden");
    getElementById("plantemplate_data").classList.remove("hidden")
  }

  private populateWeekday(day: EWeekday, dateElement: HTMLElement, id: number) {
    getChildElementSelector(dateElement, "dayName").textContent = day;

    const mealTemplate = dateElement.querySelector("[data-for-each=meal]") as HTMLElement;
    mealTemplate.classList.remove("hidden")
    const userNameTemplate = dateElement.querySelector("[data-for-each=userName]") as HTMLElement;
    userNameTemplate.classList.remove("hidden");
    const userNameTemplateParent = userNameTemplate.parentElement as HTMLElement;
    this.householdUsers.forEach((user) => {
      const userName = userNameTemplate.cloneNode(true) as HTMLElement;
      userName.textContent = user.first_name;
      userNameTemplateParent.appendChild(userName);
    });
    userNameTemplate.classList.add("hidden");
    userNameTemplate.remove();
    Meals.forEach((meal) => {
      const mealElement = mealTemplate.cloneNode(true) as HTMLElement;
      dateElement.appendChild(mealElement);
      getChildElementSelector(mealElement, "mealName").textContent = meal;
      const mealUserTemplate = getChildElementSelector(mealElement, "mealPlanItem");
      getChildElementSelector(mealElement, "userNameContainer").classList.add("grid", `grid-cols-${this.householdUsers.length}`);
      this.householdUsers.forEach((user) => {
        const templateItem = new MealPlanTemplateItem(id, user, day, meal);
        mealUserTemplate.appendChild(templateItem);
      })
      mealUserTemplate.classList.add("grid", `grid-cols-${this.householdUsers.length}`);
    })
    mealTemplate.classList.add("hidden");
  }

  private async createNewTemplate(): Promise<void> {
    // TODO: Implement this
    // try {
    //   const newTemplate = await postApi(apiUrl, "mealplantemplate", {}, apiToken);
    //   this.planTemplates.push(newTemplate.template_id);
    //   this.loadMealPlanTemplate(newTemplate.template_id);
    // } catch (e: any) {
    //   console.log(e);
    //   this.message.timedMessage(`⚠ ${e} ⚠`);
    //   setError("plantemplate");
    // }
  }
}
